<template>
    <section class="content">
        <div class="container-fluid">
            <div class="row">

                <div class="col-12">

                    <div class="card">
                        <div class="card-header">
                            <h3 class="card-title">{{ $t('contracts_list') }}</h3>

                            <div class="card-tools">
                            </div>
                        </div>
                        <!-- /.card-header -->
                        <div class="card-body table-responsive p-0">
                            <table class="table table-hover">
                                <thead>
                                <tr>
                                    <th>{{ $t('film') }}</th>
                                    <th>{{ $t('year') }}</th>
                                    <th>{{ $t('start') }}</th>
                                    <th>{{ $t('end') }}</th>
                                    <th>{{ $t('automatic_renewal') }}</th>
                                    <th>{{ $t('view_contract') }}</th>
                                    <th>{{ $t('main_terms') }}</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="contract in contracts.data" :key="contract.id">
                                    <td>{{ contract.movie.title_international }}</td>
                                    <td>{{ contract.movie.year }}</td>
                                    <td>{{ contract.start | dateFormat }}</td>
                                    <td>{{ contract.end }}</td>
                                    <td>
                                        <span :inner-html.prop="contract.self_renewal | yesno"/>
                                    </td>
                                    <td>
                                        <a v-for="(filePath,index) in contract.filesPath" :href="filePath">
                                            {{ $t('Contract') }}
                                        </a>
                                    </td>
                                    <td>
                                        <a href="#" @click="goToContract(contract.id)">
                                            <i class="fa fa-eye blue"></i>
                                        </a>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <!-- /.card-body -->
                        <div class="card-footer">
                            <pagination :data="contracts" @pagination-change-page="getResults"></pagination>
                        </div>
                    </div>
                    <!-- /.card -->
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import contracts from "../services/api/contracts";

export default {
    name: "ContractsList",
    data() {
        return {
            contracts: {},
        }
    },
    methods: {
        getResults(page = 1) {
            this.$Progress.start();
            let queryString = new URLSearchParams({page: page})
            contracts.index(queryString).then(({data}) => (this.contracts = data.data));
            this.$Progress.finish();
        },
        loadContracts() {
            contracts.index().then(({data}) => (this.contracts = data.data));
        },
        goToContract(contractId) {
            this.$router.push('contract/' + contractId)
        }
    },
    created() {
        this.$Progress.start();
        this.loadContracts();
        this.$Progress.finish();
    },
}
</script>

<style scoped>

</style>
